import React from 'react';
import PropTypes from 'prop-types';
import './loader.css';

function Loader(props) {
    return(
        <>
            { props.loader ? <div className="loader__wrapper">Loading...</div> : null }
        </>
    )
};

Loader.propTypes = {
    loader: PropTypes.bool.isRequired
};

export default Loader;
